import React, { useContext, useEffect, useState } from 'react'
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import { UserContext } from '../../../App';
import dao from '../../../assets/img/dao.png'
import postnord from '../../../assets/img/postnord.png'
import gls from '../../../assets/img/gls.png'
import bring from '../../../assets/img/bring.png'
import Modal from './modal';
import labelless from '../../../assets/img/labelless.png'
import { LoadingFull } from '../../loading';

export const BuyerDetails = ({dbBook, soldBook}) => {

  const [data, setData] = useState([]);
  const [date, setDate] = useState('...')
  const [errorMessage, setErrorMessage] = useState('')
  const [successMessage, setSuccessMessage] = useState('')
  const [open, setOpen] = useState(false)
  const [servicePoints, setServicePoints] = useState([]);
  const navigate = useNavigate()
  const { auth, user } = useContext(UserContext)
  const userId = user._id
  const token = localStorage.getItem('token')
  const [carriers, setCarriers] = useState({
    'dao': {
      'code': 'DAO_STS',
      'name': 'dao'
    },
    'gls': {
      'code': 'GLSDK_SD',
      'name': 'GLS'
    },
    'bring': {
      'code': 'BRI_PP',
      'name': 'Bring'
    },
    'pdk': {
      'code': 'PDK_MC',
      'name': 'PostNord'
    },
    'ups': {
      'code': 'UPS_STANDARDAP',
      'name': 'UPS'
    }
  })

  useEffect(() => {
    axios({
        method: 'post',
        url: '/api/getDate',
        data: {
            'dbId': dbBook._id
        }
    })
      .then(response => {
        setDate(response.data);
      })
      .catch(error => {
        console.log(error);
      });
  }, [])

  function getServicePoints() {
    if (typeof user.address !== 'undefined') {
      axios({
        method: 'post',
        url: '/api/pickup_points',
        data: {
            'carrierCodes': [soldBook['carrier_code']],
            'zipcode': user.address.postal_code,
            'address': user.address.line1,
            'city': user.address.city,
            'type': "in_delivery"
        },
        headers: {
            Authorization: `Bearer ${token}`
        }
      })
      .then(response => {
          setServicePoints(response.data)
          setOpen(true)
          console.log(response.data)
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
  
  return (
    <div className="buyerDetails flex flex-col flex-wrap gap-5 shadow-lg p-10 w-full box-border">
      <h2 className="text-sm md:text-base font-bold">Forsendelsesoplysninger</h2>
      <div className="gap-y-8 flex flex-col">
        <div className="w-full">
          <label for="name" class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">Afsendelsesfrist</label>
          <div className="flex gap-2 relative items-center max-w-96">
            {(date !== 1) ?
              <h2 className="text-sm">Du har <span className="font-medium">{date} dage</span> tilbage</h2>
            :
              <h2 className="text-sm">Du har <span className="font-medium">{date} dag</span> tilbage</h2>
            }
            <div className="flex group flex-wrap-reverse" tabindex="0">
              <div className="q-mark cursor-pointer group-focus:text-gray-500">
                <svg class="w-4 h-4 text-gray-400 hover:text-gray-500" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg><span class="sr-only">Show information</span>
              </div>
              <div className="z-10 invisible opacity-0 group-hover:visible group-hover:opacity-100 group-focus:visible group-focus:opacity-100 transition-opacity duration-100 absolute top-[20px] w-full left-0">
                <div class="q-text right-0 top-[20px] w-full text-sm bg-white border border-gray-200 rounded-lg shadow-sm">
                  <div class="px-3 py-2 bg-gray-100 border-b border-gray-200 rounded-t-lg dark:border-gray-600 dark:bg-gray-700">
                      <h3 class="font-semibold text-gray-900 dark:text-white">Afsendelsesfrist</h3>
                  </div>
                  <div class="px-3 py-2 flex flex-col gap-2">
                    <p>Bogen skal afsendes med posten <span className="font-semibold">senest 5 dage efter</span> købet er sket.</p>
                    <hr></hr>
                    <p>Overholdes dette ikke, refunderes pengene til køber.</p>
                  </div>
                  <div data-popper-arrow></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="w-full">
          <label for="name" class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">Forsendelsesfirma</label>
          <div className="img h-4 md:h-6 w-fit">
            <img src={
              (soldBook['carrier_code'] === 'dao') ?
                dao
              : (soldBook['carrier_code'] === 'pdk') ?
                postnord
              : (soldBook['carrier_code'] === 'gls') ?
                gls
              : (soldBook['carrier_code'] === 'bring') ?
                bring
              :
                ""
            } className="h-full w-full object-contain" />
          </div>
        </div>
        <div className="w-full">
            <label for="gadenavn" class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">Pakkelabel</label>
            <div className="flex gap-x-5 gap-y-2 flex-wrap relative w-fit">
              <div className="flex flex-col">
                <div className="flex gap-2 items-center">
                  <h2 className="text-nowrap text-sm">Labelless-kode</h2>
                  <div className="flex group flex-wrap-reverse" tabindex="0">
                    <div className="q-mark cursor-pointer group-focus:text-gray-500">
                      <svg class="w-4 h-4 text-gray-400 hover:text-gray-500" aria-hidden="true" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-8-3a1 1 0 00-.867.5 1 1 0 11-1.731-1A3 3 0 0113 8a3.001 3.001 0 01-2 2.83V11a1 1 0 11-2 0v-1a1 1 0 011-1 1 1 0 100-2zm0 8a1 1 0 100-2 1 1 0 000 2z" clip-rule="evenodd"></path></svg><span class="sr-only">Show information</span>
                    </div>
                    <div className="z-10 invisible opacity-0 group-hover:visible group-hover:opacity-100 group-focus:visible group-focus:opacity-100 transition-opacity duration-100 absolute top-[20px] w-full left-0">
                      <div class="q-text right-0 top-[20px] w-full max-w-64 text-sm bg-white border border-gray-200 rounded-lg shadow-sm">
                        <div class="px-3 py-2 bg-gray-100 border-b border-gray-200 rounded-t-lg dark:border-gray-600 dark:bg-gray-700">
                            <h3 class="font-semibold text-gray-900 dark:text-white">Labelless-kode</h3>
                        </div>
                        <div class="px-3 py-2 flex flex-col gap-2">
                          <p className="font-medium">Send pakke uden at printe</p>
                          <hr></hr>
                          <p>Det eneste, du skal gøre er at skrive din ni-cifret <span className="italic">labelless-kode</span> på din pakke med vandfast tusch, hvorefter pakken indleveres i en <span className="font-semibold">{carriers[soldBook['carrier_code']]['name']}</span> pakkeshop nær dig.</p>
                          <div className="w-full">
                            <img src={labelless} />
                          </div>
                        </div>
                        <div data-popper-arrow></div>
                      </div>
                    </div>
                  </div>
                </div>
                <p className="text-nowrap font-semibold">{soldBook['labelless_code']}</p>
              </div>
              <div className="flex flex-col">
                <h2 className="text-nowrap text-sm">Label til print</h2>
                <a
                          className="text-nowrap underline"
                          download="label.pdf"
                          href={"#"}//`data:application/pdf;base64,${soldBook[0]['base64']}`}
                      >Print label
                </a>
              </div>
            </div>
        </div>
        <div className="w-full">
            <label for="gadenavn" class="block text-sm font-semibold text-gray-900 dark:text-white mb-2">Indleveringssted</label>
            <h2 className="text-sm">Aflever pakken i en <span className="font-semibold">{carriers[soldBook['carrier_code']]['name']}</span> pakkeshop nær dig</h2>
            <h2 className="text-sm underline cursor-pointer" onClick={() => getServicePoints()}>Find pakkeshops i nærheden</h2>
        </div>
      </div>
      <Modal width={"w-[80%] lg:w-2/5"} height={"4/5"} open={open} onClose={() => setOpen(false)}>
        {(typeof servicePoints === 'undefined') ?
          <LoadingFull />
        :
          <div className="flex flex-col h-full gap-5">
            <div className="title">
              <h3 className="text-base lg:text-2xl font-bold">Indleveringssteder</h3>
              <p className="text-sm lg:text-base">{servicePoints.length} indleveringssteder fundet</p>
            </div>
            <div className="overflow-y-scroll overflow-x-hidden grid grid-cols-2 h-full">
              {servicePoints.map((point, index) => {
                return (
                  <div className="py-5 border border-gray-100 flex justify-between px-2">
                    <div className="transition-[opacity_0.2s] text-xs lg:text-sm w-full flex flex-col gap-2">
                      <div className="nameAndPrice flex justify-between items-center">
                        <div className="img w-auto h-3 sm:h-4">
                          <img src={
                            (point.carrier_code === 'dao') ?
                              dao
                            : (point.carrier_code === 'pdk') ?
                              postnord
                            : (point.carrier_code === 'gls') ?
                              gls
                            : (point.carrier_code === 'bring') ?
                              bring
                            :
                              ""
                          } className="h-full w-full object-contain" />
                        </div>
                      </div>
                      <div className="h-full">
                        <div className="flex gap-2 items-center">
                          <p className="font-semibold">{point.name}</p> 
                        </div>
                        <div className="address">
                          <p className="">{point.address}</p>
                          <p>{point.zipcode}, {point.city}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              })}
            </div>
          </div>
        }
      </Modal>
    </div>
  )
}